import { Injectable } from '@angular/core';
import { LogService } from './log.service';

@Injectable({
	providedIn: 'root',
})
export class FormExtractorService {


	private LOG: LogService = new LogService(FormExtractorService);

	constructor() { }

	/**
	 * cette fonction permet d'extraire les index dans un controle Name
	 *  en se basant sur des keys , filters et un splitter
	 * elle renvoie un tableau d'index
	 * exemple 	_STEP_ID_6_SepSep_TypeAnn_JOUE_17_SepSep_TypeJOUELots_index_1
	 * 		   	_STEP_ID_6_SepSep_TypeAnn_JOUE_17_SepSep_TypeJOUELots_index_2
	 * 			_STEP_ID_6_SepSep_TypeAnn_JOUE_17_SepSep_TypeJOUELots_index_4
	 * dans ce cas cette fonction renvoie [1,2,null,4]
	 *
	 * 1,2,3,4
	 * 1,3,4
	 *
	 *
	 *
	 * @param keys
	 * @param filters
	 * @param splitter
	 * @returns
	 */
	public getIndexes(keys: string[], filters: string[], splitter: string): Set<number> {

		const set = new Set(
			keys
				.filter((e) => {
					let bool = true;
					filters.forEach((f) => {
						if (!(e.includes(f) && e.includes(splitter))) {
							bool = false;
						}
					});
					return bool;
				})
				.map((e) => {
					return e.split(splitter)[1];
				})
				.map((e) => {
					return parseInt(e.split('_')[0]);
				})
		);
		// préparer le tableau complet
		let max = set.size;
		set.forEach(e => {
			if (e > max) {
				max = e;
			}
		});
		const setToReturn = new Set<any>();
		for (let i = 1; i < max + 1; i++) {
			if (set.has(i)) {
				setToReturn.add(i);
			} else {
				setToReturn.add(null);
			}
		}
		return setToReturn;
	}

	public getMapControlsIdWithoutStepAndValue(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((key) => {
			const regEx = /_STEP_ID_\d+(\.\d+)?/;
			const keyWithoutStepId = key.replace(regEx, '');
			controls.set(keyWithoutStepId, form.controls[key].value);
		});
		return controls;
	}

	public getMapControlsIdWithStepAndValue(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((key) => {
			controls.set(key, form.controls[key].value);
		});
		return controls;
	}

	public getMapControlsIdWithoutStepAndValueCommon(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((key) => {
			const regEx = /_STEP_ID_\d+/;
			const keyWithoutStepId = key.replace(regEx, '');
			controls.set(keyWithoutStepId, form.controls[key].value);
		});
		return controls;
	}

	public getMap_ControlsID_ControlsIDWithoutStepId(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((keyWithId) => {
			const regEx = /_STEP_ID_\d+(\.\d+)?/;
			const keyWithoutId = keyWithId.replace(regEx, '');
			controls.set(keyWithoutId, keyWithId);
		});
		return controls;
	}

	public getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((keyWithId) => {
			const regEx = /_STEP_ID_\d+(\.\d+)?/;
			const regExCommon = /_STEP_ID_\d+(\.\d+)?/;
			let keyWithoutId = keyWithId.replace(regEx, '');
			keyWithoutId = keyWithoutId.replace(regExCommon, '');
			controls.set(keyWithoutId, keyWithId);
		});
		return controls;
	}


	public getMap_ControlsIDWithoutStepIdCommonId_ControlsID(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((keyWithId) => {
			const regEx = /_STEP_ID_\d+(\.\d+)?/;
			const regExCommon = /_STEP_ID_\d+(\.\d+)?/;
			let keyWithoutId = keyWithId.replace(regEx, '');
			keyWithoutId = keyWithoutId.replace(regExCommon, '');
			controls.set(keyWithId, keyWithoutId);
		});
		return controls;
	}

	public getMapValue_ControlsID_ControlsIDWithoutStepIdCommonId(form) {
		const controls = new Map();
		Object.keys(form.controls).forEach((keyWithId) => {
			const regEx = /_STEP_ID_\d+(\.\d+)?/;
			const regExCommon = /_STEP_ID_\d+(\.\d+)?/;
			let keyWithoutId = keyWithId.replace(regEx, '');
			keyWithoutId = keyWithoutId.replace(regExCommon, '');
			controls.set(keyWithoutId, form.controls[keyWithId].value);
		});
		return controls;
	}

	setValueFromControlName(value: any, attribut: any[]) {
		if (value && value != '') {
			attribut[attribut.length++] = value;
		}
	}

	getValueFacturationByFilter(form) {
		let siret;
		let service;
		let engagementJuridique;
		let classeProfil;
		let typeEntite;
		let identifiantAdressage;
		Object.keys(form.controls).forEach((key) => {
			if (key.includes('TypeFacturation') && key.includes('siret') && form.controls[key]) {
				siret = form.controls[key];
			}
			if (key.includes('TypeFacturation') && key.includes('noServiceExecutant') && form.controls[key]) {
				service = form.controls[key];
			}
			if (key.includes('TypeFacturation') && key.includes('numBonCommande') && form.controls[key]){
				engagementJuridique = form.controls[key];
			}
			if (key.includes('TypeFacturation') && key.includes('ClasseProfit') && form.controls[key]){
				classeProfil = form.controls[key];
			}
			if (key.includes('TypeFacturation') && key.endsWith('_SepAtt_typeEntite') && form.controls[key]){
				typeEntite = form.controls[key];
			}
			if (key.includes('TypeFacturation') && key.endsWith('_SepAtt_identifiantAdressage') && form.controls[key]){
				identifiantAdressage = form.controls[key];
			}
		});
		return {
			siret: siret?.value,
			service: service?.value,
			engagementJuridique: engagementJuridique?.value,
			classeProfil: classeProfil?.value,
			typeEntite: typeEntite?.value,
			identifiantAdressage: identifiantAdressage?.value
		};
	}

	getCommonJoue(form){

	}
}
